export {isMobileView};

function isMobileView(){
  return window.innerWidth<768;
}
var currentStatus = isMobileView();
window.onresize = function(){
  if(currentStatus!==isMobileView()){
    window.location.reload();
  }
}